import { loadJsonFromUrl } from "../util/json-loader";
import { EventType } from "./event-type";

export interface WebEvent {
  type: EventType;
  startTime: Date;
  endTime: Date;
  topic: string | null;
  description: string | null;
  presenter: string | null;
  location: string;
  link?: string | null;
  linkText?: string | null;
}

interface RawWebEvent {
  type: EventType;
  startTime: string;
  endTime: string;
  topic?: string | null;
  description?: string | null;
  presenter?: string | null;
  location: string;
  link?: string | null;
  linkText?: string | null;
}

const EVENTS_JSON_URL =
  "https://assets.richmondwoodturners.org/events/events.json";

export async function getWebEvents(): Promise<WebEvent[] | null> {
  const events = await loadJsonFromUrl<RawWebEvent[]>(EVENTS_JSON_URL);
  if (events === null) {
    console.error(
      `Failed to load web events from ${EVENTS_JSON_URL}. Returning null.`,
    );
    return null;
  }

  return events
    .map((event) => parseWebEvent(event))
    .filter((event) => event.endTime > new Date());
}

function parseWebEvent(event: RawWebEvent): WebEvent {
  return {
    ...event,
    startTime: new Date(event.startTime),
    endTime: new Date(event.endTime),
    topic: event.topic ?? null,
    description: event.description ?? null,
    presenter: event.presenter ?? null,
    link: event.link ?? null,
    linkText: event.linkText ?? null,
  };
}
